// extracted by mini-css-extract-plugin
module.exports = {"leftHandContainer":"Productos_leftHandContainer__2IRmX","emptyBody":"Productos_emptyBody__1pLM7","categoriaSelectorMobile":"Productos_categoriaSelectorMobile__OM4SS"};